import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import { useEffect, useState } from "react";
import axios from "axios";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import DateSelect from "../../globalno-dodavanje/DateSelect";
import CustomSelectKey from "./CustomSelectKey";
import FotografijaModal from "./FotografijaModal";
import CustomAutocomplete from "./CustomAutocomplete";

const emptyData = {
  vrsta: { id: -1, name: "" },
  tip: { id: -1, name: "" },
  lokacija: "",
  odgovoran: { id: -1, name: "" },
  istice: "",
  stanje: "",
  fotoFile: undefined,
  fotoLink: null,
};

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold", width: "15vw" },
};

function DodavanjeSredstva({ setIsDodavanje, setSredstva, editId, setEditId, onSaved }) {
  const [data, setData] = useState(emptyData);
  const [vrsteAll, setVrsteAll] = useState([]);
  const [tipovi, setTipovi] = useState([]);
  const [lokacijeAll, setLokacijeAll] = useState([]);
  const [zaposleniAll, setZaposleniAll] = useState([]);
  const [isOpenFotografijaModal, setIsOpenFotografijaModal] = useState(false);

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  // Učitaj lookups
  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    const cid = selectedMainEntity.company_id;

    axios.post(`${baseUrl}/spp/get_lookups.php`, { company_id: cid })
      .then(({ data: res }) => { if (res.status === 200) setVrsteAll(res.vrste); })
      .catch(console.error);

    axios.post(`${baseUrl}/machines/getAllLocations.php`, { company_id: cid })
      .then(({ data: res }) => { if (res.status === 200) setLokacijeAll(res.data); })
      .catch(console.error);

    axios.post(`${baseUrl}/evidencija6/get_lookups.php`, { company_id: cid })
      .then(({ data: res }) => { if (res.status === 200) setZaposleniAll(res.zaposleni); })
      .catch(console.error);
  }, [selectedMainEntity]);

  // Ako edit — učitaj podatke
  useEffect(() => {
    if (!editId || !selectedMainEntity?.company_id) return;
    axios.post(`${baseUrl}/spp/get_one.php`, { sredstvo_id: editId, company_id: selectedMainEntity.company_id })
      .then(({ data: res }) => {
        if (res.status === 200) {
          const sr = res.data;
          setData({
            vrsta: { id: sr.vrsta_id, name: sr.vrsta },
            tip: { id: sr.tip_id, name: sr.tip },
            lokacija: sr.lokacija || "",
            odgovoran: { id: sr.odgovoran_id, name: sr.odgovoran_naziv },
            istice: sr.datum_isteka || "",
            stanje: sr.stanje,
            fotoFile: undefined,
            fotoLink: sr.foto_path ? `${baseUrl.replace("/api", "")}/${sr.foto_path}` : null,
            existing_foto_path: sr.foto_path || "",
          });
        }
      })
      .catch(console.error);
  }, [editId]);

  // Kad se promeni vrsta, postavi tipove
  useEffect(() => {
    const vrs = vrsteAll.find((v) => v.id === data.vrsta.id);
    setTipovi(vrs?.tipovi || []);
    if (!editId) setData((prev) => ({ ...prev, tip: { id: -1, name: "" } }));
  }, [data.vrsta.id, vrsteAll]);

  const handleChange = (newValue, field) => setData((prev) => ({ ...prev, [field]: newValue }));

  const handleClose = () => {
    setIsDodavanje(false);
    if (editId) setEditId("");
    setData(emptyData);
  };

  const handleSacuvaj = async () => {
    const formData = new FormData();
    formData.append("company_id", selectedMainEntity.company_id);
    formData.append("tip_id", data.tip.id);
    formData.append("lokacija", data.lokacija);
    formData.append("odgovoran_id", data.odgovoran.id !== -1 ? data.odgovoran.id : "");
    formData.append("stanje", data.stanje ? "1" : "0");
    if (data.istice) formData.append("datum_isteka", data.istice);
    if (editId) formData.append("sredstvo_id", editId);
    if (data.fotoFile) formData.append("foto", data.fotoFile);
    else {
      formData.append("existing_foto_path", data.existing_foto_path || "");
      if (!data.fotoLink && editId) formData.append("delete_foto", "1");
    }

    try {
      const { data: res } = await axios.post(`${baseUrl}/spp/upsert.php`, formData);
      if (res.status === 200) {
        onSaved?.();
        handleClose();
      } else {
        alert(res.message || "Greška pri čuvanju.");
      }
    } catch (e) {
      console.error(e);
      alert("Greška na serveru.");
    }
  };

  const handleIzbrisi = async () => {
    if (!window.confirm("Obrisati ovo sredstvo?")) return;
    try {
      const { data: res } = await axios.post(`${baseUrl}/spp/delete.php`, {
        sredstvo_id: editId,
        company_id: selectedMainEntity.company_id,
      });
      if (res.status === 200) { onSaved?.(); handleClose(); }
    } catch (e) { console.error(e); }
  };

  const handleConfirmFoto = (file, newFotoLink) => {
    setData((prev) => ({ ...prev, fotoFile: file, fotoLink: newFotoLink || null }));
    setIsOpenFotografijaModal(false);
  };

  const ima_datum_isteka = tipovi.find((t) => t.id === data.tip.id)?.ima_datum_isteka || false;

  const isDisabledSacuvaj =
    !data.vrsta.name || !data.tip.name || !data.lokacija ||
    !data.odgovoran.name || data.stanje === "" ||
    (ima_datum_isteka && (!data.istice || data.istice.includes("undefined")));

  return (
    <div>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-end", justifyContent: "space-between", paddingTop: "10px" }}>
        <div style={{ width: "17vw" }}>
          <CustomSelect label={dictionary["vrsta"]} allValues={vrsteAll} selectedValue={data.vrsta}
            onSelectChange={(v) => handleChange(v, "vrsta")} readOnly={!!editId} />
        </div>
        <div style={{ width: "15vw" }}>
          <CustomSelect label={dictionary["tip"]} allValues={tipovi} selectedValue={data.tip}
            onSelectChange={(v) => handleChange(v, "tip")} readOnly={!!editId} />
        </div>
        <div style={{ width: "15vw" }}>
          <CustomAutocomplete label={dictionary["lokacija"]} allValues={lokacijeAll} selectedValue={data.lokacija}
            onSelectChange={(v) => handleChange(v, "lokacija")} />
        </div>
        <CustomSelectKey selectedValue={data.stanje} onSelectChange={(v) => handleChange(v, "stanje")} />
        <div style={{ width: "15vw" }}>
          <CustomSelect label={dictionary["odgovoranZaStanje"]} allValues={zaposleniAll} selectedValue={data.odgovoran}
            onSelectChange={(v) => handleChange(v, "odgovoran")} />
        </div>
        {ima_datum_isteka && (
          <DateSelect label={dictionary["istice"]} selectedValue={data.istice}
            onSelectChange={(v) => handleChange(v, "istice")} />
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "15px" }}>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {editId && <div style={{ fontSize: "36px", fontWeight: "bold" }}>2.</div>}
          <div onClick={() => setIsOpenFotografijaModal(true)}>
            <Button activation={true} style={{ ...styles.button, width: "17vw" }}>
              {data.fotoLink ? dictionary["izmeniFotografiju"] : dictionary["ucitajFotografiju"]}
            </Button>
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={handleClose}>
            <Button activation={true} style={styles.button}>{dictionary["odustani"]}</Button>
          </div>
          {editId && (
            <div onClick={handleIzbrisi}>
              <Button activation={true} style={styles.button}>{dictionary["izbrisi"]}</Button>
            </div>
          )}
          <div onClick={isDisabledSacuvaj ? undefined : handleSacuvaj} style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}>
            <Button isDisabled={isDisabledSacuvaj} activation={true} style={styles.button}>
              {editId ? dictionary["izmeni"] : dictionary["sacuvaj"]}
            </Button>
          </div>
        </div>
      </div>

      {isOpenFotografijaModal && (
        <FotografijaModal
          handleConfirm={handleConfirmFoto}
          handleCancel={() => setIsOpenFotografijaModal(false)}
          fotoLink={data.fotoLink}
          fotoFile={data.fotoFile}
        />
      )}
    </div>
  );
}

export default DodavanjeSredstva;